import React, { useState } from "react";
import { ChangeCard } from "../components/Shared";

export default function Changes({ changes, onRefresh }) {
  const [filter, setFilter] = useState("all");

  const filtered = changes.filter((c) => {
    if (filter === "urgent") return c.classification?.urgency === "immediate";
    if (filter === "short") return c.classification?.urgency === "short_term";
    if (filter === "monitor") return c.classification?.urgency === "monitor";
    return true;
  });

  // Group by competitor
  const byCompetitor = {};
  filtered.forEach((c) => {
    const name = c.competitor || "Unknown";
    if (!byCompetitor[name]) byCompetitor[name] = [];
    byCompetitor[name].push(c);
  });

  const urgent = changes.filter((c) => c.classification?.urgency === "immediate");
  const totalUrgent = urgent.length;

  return (
    <div className="space-y-6">
      {/* Heading */}
      <div>
        <h1 className="page-title">Changes & Alerts</h1>
        <p className="page-subtitle">
          {changes.length} change{changes.length !== 1 ? "s" : ""} tracked
          {totalUrgent > 0 && <span className="text-red-600 font-medium ml-2">· {totalUrgent} urgent</span>}
        </p>
      </div>

      {/* Alert banner for urgent */}
      {urgent.length > 0 && (
        <div className="card border-red-200 bg-red-50">
          <div className="card-body flex items-start gap-3">
            <span className="text-lg">🔴</span>
            <div>
              <h3 className="font-semibold text-red-800 text-sm">{urgent.length} Urgent Alert{urgent.length > 1 ? "s" : ""}</h3>
              <p className="text-xs text-red-700 mt-1">
                {urgent.map((c) => c.competitor).join(", ")} — requires attention
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Filters */}
      <div className="flex items-center gap-2 flex-wrap">
        {[
          { key: "all", label: `All (${changes.length})` },
          { key: "urgent", label: `🔴 Urgent (${changes.filter((c) => c.classification?.urgency === "immediate").length})` },
          { key: "short", label: `🟡 Watch (${changes.filter((c) => c.classification?.urgency === "short_term").length})` },
          { key: "monitor", label: `🟢 Monitor (${changes.filter((c) => (c.classification?.urgency || "monitor") === "monitor").length})` },
        ].map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setFilter(key)}
            className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
              filter === key
                ? "bg-gray-900 text-white"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Alerts config note */}
      <div className="card bg-gray-50 border-gray-200">
        <div className="card-body flex items-center gap-4 text-sm text-gray-500">
          <span>🔔</span>
          <span>
            Alerts for immediate/short-term urgency changes are sent via <strong>Slack</strong> and <strong>Email</strong>
            {" "}(1901739965@qq.com). Configure in <code className="bg-gray-200 px-1 rounded text-xs">.env</code>.
          </span>
        </div>
      </div>

      {/* Changes list */}
      {filtered.length === 0 ? (
        <div className="empty-state">
          <p className="text-lg mb-1">No {filter === "all" ? "" : filter + " "}changes</p>
          <p className="text-sm">All competitor content is stable.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {filtered.map((c, i) => <ChangeCard key={i} change={c} />)}
        </div>
      )}
    </div>
  );
}
